import { render, staticRenderFns } from "./Applied.vue?vue&type=template&id=68dbb510&scoped=true&"
import script from "./Applied.vue?vue&type=script&lang=ts&"
export * from "./Applied.vue?vue&type=script&lang=ts&"
import style0 from "./Applied.vue?vue&type=style&index=0&id=68dbb510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dbb510",
  null
  
)

export default component.exports